<template>
  <div class="container" v-if="index < 10 || index == 20">
    <div class="top">
      <div class="wapper w12 flex_a">
        <ul>
          <li @click="toManagerHome">平台首页</li>
          <li @click="toResources">资源中心</li>
          <li class="checked">知识中心</li>
          <li @click="toBookCenter">资讯及书展</li>
          <li @click="toSphome">机构采选</li>
          <li @click="toPay">支付服务</li>
        </ul>
        <div class="login-wrapper">
          <div v-if="isLogin" class="login">
            <span @click="toCenter">个人中心</span>
            <span class="line">|</span>
            <span @click="confirmLogout">退出</span>
          </div>
          <div v-else class="login">
            <span @click="doLogin">登录</span>
            <span class="line">|</span>
            <span @click="doSignUp">注册</span>
          </div>
          <login-menu
            :showLogin="showLogin"
            :tab="loginTab"
            @close-dialog="closeDialog"
          />
        </div>
      </div>
    </div>
    <div class="header w12">
      <div class="flex_a">
        <img
          src="../../assets/images/zszx-logo.png"
          alt=""
          @click="toIndex"
          style="cursor: pointer;"
        />
        <div class="aList flex">
          <router-link :to="{ name: 'home' }" :class="index == 1 ? 'checked' : ''">
            首页
          </router-link>
          <router-link :to="{ name: 'hot' }" :class="index == 2 ? 'checked' : ''">
            热点专题
          </router-link>
          <router-link
            :to="{ name: 'list', query: { from: 3 } }"
            :class="index == 3 ? 'checked' : ''"
          >
            图书榜单
          </router-link>
          <!-- <router-link :to="{name:'recommend'}" :class="index == 4 ? 'checked' : ''">编辑评论</router-link> -->
          <router-link
            :to="{ name: 'list', query: { from: 5 } }"
            :class="index == 5 ? 'checked' : ''"
          >
            作者
          </router-link>
          <router-link
            :to="{ name: 'list', query: { from: 6 } }"
            :class="index == 6 ? 'checked' : ''"
          >
            奖项
          </router-link>
          <router-link
            :to="{ name: 'list', query: { from: 7 } }"
            :class="index == 7 ? 'checked' : ''"
          >
            丛书
          </router-link>
          <router-link
            :to="{ name: 'list', query: { from: 8 } }"
            :class="index == 8 ? 'checked' : ''"
          >
            出版社
          </router-link>
          <router-link
            :to="{ name: 'list', query: { from: 9 } }"
            :class="index == 9 ? 'checked' : ''"
          >
            图书馆
          </router-link>
        </div>
      </div>
    </div>
    <!-- 搜索 -->
    <div class="banner" v-if="index == 1">
      <div class="search flex_a">
        <el-input
          class="searchInput"
          placeholder="请输入要检索的内容"
          v-model="keyword"
          @keyup.enter.native="toSearch"
          clearable
        ></el-input>
        <img @click="toSearch" src="../../assets/images/search.png" alt="" />
      </div>
    </div>
    <div class="banner2 banner" v-else>
      <div class="search flex_a">
        <el-input
          class="searchInput"
          placeholder="请输入要检索的内容"
          v-model="keyword"
          @keyup.enter.native="toSearch"
          clearable
        ></el-input>
        <img @click="toSearch" src="../../assets/images/search.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import loginMenu from './LoginMenu.vue'
import urlSet from '@/utils/url'

export default {
  name: 'home',
  components: {
    loginMenu,
  },
  data() {
    return {
      index: 100,
      path: '',
      keyword: '',
      loginFlag: false,
      customercode: '',
      showLogin: false,
      loginTab: 0,
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.path = val.path
        this.keyword = ''

        if (val.name == 'home') {
          this.index = 1
        }
        if (val.name == 'hot' || val.name == 'hotDetail') {
          this.index = 2
        }
        if (val.name == 'rankDetail') {
          this.index = 3
        }
        if (val.name == 'bookDetail') {
          if (val.query.type == 1) {
            this.index = 2
          }
          if (val.query.type == 2) {
            this.index = 3
          }
          if (val.query.type == 3) {
            this.index = 4
          }
          if (val.query.type == 4) {
            this.index = 5
          }
          if (val.query.type == 5) {
            this.index = 6
          }
          if (val.query.type == 6) {
            this.index = 7
          }
        }
        if (val.name == 'recommend') {
          this.index = 4
        }
        if (val.name == 'authorDetail') {
          this.index = 5
        }
        if (val.name == 'prizeDetail') {
          this.index = 6
        }
        if (val.name == 'seriesDetail') {
          this.index = 7
        }
        if (val.name == 'list') {
          if (val.query.from == 3) {
            this.index = 3
          }
          if (val.query.from == 5) {
            this.index = 5
          }
          if (val.query.from == 6) {
            this.index = 6
          }
          if (val.query.from == 7) {
            this.index = 7
          }
          if (val.query.from == 8) {
            this.index = 8
          }
          if (val.query.from == 9) {
            this.index = 9
          }
        }
        if (val.name == 'publisher' || val.name == 'publisherdetail') {
          this.index = 8
        }
        if (val.name == 'library' || val.name == 'librarydetail') {
          this.index = 9
        }
        if (val.name == 'search') {
          this.index = 20
        } else {
          this.$store.commit('setSearch', '')
        }

        if (val.name == 'ibhome') {
          this.index = 10
        }
        if (
          val.name == 'ibresultlist' ||
          val.name == 'searchlist' ||
          val.name == 'firelist'
        ) {
          this.index = 11
        }
        if (val.name == 'ibinfordetail') {
          this.index = 12
        }
        console.log(val.name)
        if (
          val.name == 'managerhome' ||
          val.name == 'searchresult' ||
          val.name == 'noticdetail' ||
          val.name == 'nopage' ||
          val.name == 'homeStationClassify'
        ) {
          this.index = 13
        }
        this.keyword = this.$store.state.searchVal
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.customercode = localStorage.getItem('customerCode')
  },
  mounted() {},
  computed: {
    isLogin() {
      const token = localStorage.getItem('token')
      if (token) return true
      else return false
    },
  },
  methods: {
    doLogin() {
      this.loginTab = 0
      this.showLogin = true
    },
    doSignUp() {
      this.loginTab = 1
      this.showLogin = true
    },
    closeDialog() {
      this.showLogin = false
    },
    // 确认是否退出
    confirmLogout() {
      this.$confirm('确定要退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.doLogout()
        })
        .catch(() => {
          return false
        })
    },
    doLogout() {
      this.$http.get('/api/v1/user/accountlogout').then(res => {
        if (res.cxajaxrc == 0) {
          this.$message.success('您已成功退出')
          localStorage.clear()
          location.reload()
        }
      })
    },
    toCenter() {
      window.open('/my/#/')
    },
    toManagerHome() {
      // window.location.href = '/#/managerhome'
      location.href = '/index/#/managerhome'
    },
    toIndex() {
      //window.open("/platformhomepage.html#/sphome/homepage")
      if (this.$route.name == 'home') {
        this.$router.go(0)
      }
      window.location.href = '/kc/#/home'
    },
    toPay() {
      window.location.href = '/index/#/pay'
    },
    toResources() {
      window.location.href = '/dc/#/home'
    },
    toSphome() {
      window.open(urlSet.baseUrl + '/xs/#/sphome')
    },
    getLibraryConfigByShortName(shortname) {
      this.$http({
        url: `/api/v1/login/getCustomerLoginCofig?shortName=${shortname}`,
        method: 'GET',
      }).then(res => {
        if (res.cxajaxrc == 0) {
          let customerConfig = res.returnvalue
          localStorage.setItem('CustomerLoginCofig', JSON.stringify(customerConfig))
        }
      })
    },
    toBookCenter() {
      window.location.href = '/ic/#/ibhome'
    },
    toSearch() {
      if (this.keyword.substring(0, 3) === '978') {
        this.keyword = this.lodash.replace(this.keyword, /-/g, '')
      }
      if (this.$route.path === '/search') {
        this.bus.$emit('kn-search')
        this.$store.commit('setSearch', this.keyword ? this.keyword.trim() : '')
      } else {
        this.$store.commit('setSearch', this.keyword ? this.keyword.trim() : '')
        this.$router.push({ path: '/search' })
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  .top {
    height: 45px;
    background: url('../../assets/images/top_bg.png') no-repeat;
    background-size: cover;
    .wapper {
      line-height: 45px;
      color: #fff;
      ul {
        display: flex;
        align-items: center;
        li {
          width: 105px;
          text-align: center;
          font-size: 16px;
          cursor: pointer;
        }
        .checked {
          background: #fff;
          color: #e68422;
        }
      }
      > p {
        cursor: pointer;
      }
      > div {
        margin-left: auto;
      }
    }
  }
  .header {
    img {
      height: 50px;
    }
    > div {
      margin: 20px 0;
      .aList {
        margin-left: auto;
        a {
          font-size: 18px;
          margin-left: 35px;
          cursor: pointer;
          position: relative;
          color: #333;
          &::after {
            width: 0;
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0;
            height: 2px;
            background: #e68422;
            transition: all 0.2s;
          }
          &:hover {
            color: #e68422;
          }
        }
        .checked {
          color: #e68422;
          &::after {
            width: 100%;
          }
        }
      }
    }
  }
  .banner {
    height: 270px;
    background: url('../../assets/images/banner.png') no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    .search {
      position: absolute;
      width: 650px;
      height: 55px;
      background: url('../../assets/images/search-bg.png') no-repeat;
      background-size: cover;
      left: 50%;
      transform: translateX(-50%);
      bottom: 50px;
      padding: 0 20px;
      .select {
        color: #fff;
        font-size: 16px;
        border-right: 1px solid #e68422;
        padding-right: 10px;
        span {
          width: 50px;
        }
      }
      .searchInput {
        flex: 1;
        /deep/ .el-input__inner {
          background: none;
          border: none;
          font-size: 16px;
          color: #fff;
          &::placeholder {
            color: #fff;
          }
          &::-webkit-placeholder {
            color: #fff !important;
          }
          &::-moz-placeholder {
            color: #fff !important;
          }
          &::-ms-input-placeholder {
            color: #fff !important;
          }
        }
        /deep/ .el-input__clear {
          &:hover {
            color: #fff !important;
          }
        }
        /deep/ .el-input__clear {
          color: #fff !important;
        }
      }
      img {
        margin-left: auto;
        cursor: pointer;
      }
    }
  }
  .banner2 {
    height: 160px;
    background: url('../../assets/images/banner2.png') no-repeat;
    background-size: cover;
    position: relative;
  }
}
.login-wrapper {
  .login {
    line-height: 45px;
    span {
      cursor: pointer;
    }
    .line {
      margin: 0 5px;
      padding: 0 5px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/top/index.vue